<template lang="pug">
  section#recruitment
    .section__content
      .caption
        h2.caption__text.text-hide 造局者徵才計畫<br>擴張小宇宙成就大理想
      .opportunities
        .opportunity
          .opportunity__title
            p 業務菁英人才
          .opportunity__content
            ul.opportunity__desc
              li
                p PropTech&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;房產科技助成交#[br]精準銷售不白忙
              li
                p 保障月薪 5 萬六個月#[br]30 天工作鑑賞期轉職金 5 萬
              li
                p 新人180 天全方位培育計畫#[br]百堂訓練課程及1對1師徒制
            a#read_more_elite_bd.opportunity__more(href="#" @click.prevent="setPopup({type: 'recruitment', position: 'sales'})") #[span Read More]
            ul.opportunity__buttons.buttons
              li
                a#btn_elite_bd.opportunity__button.button(:href="`https://hr.sinyi.com.tw/elite?sinFrom=202211_tvc_${targetString}`" target="_blank" @click="clickApply('sales')") #[span 我要應徵]
        .opportunity
          .opportunity__title
            p 數位科技人才
          .opportunity__content
            ul.opportunity__desc
              li
                p 打造 PropTech 自家產品#[br]高潛力的房產科技發展空間
              li
                p 多元職涯發展、海內外集團#[br]輪調機會
              li
                p 內部定期技術分享、職能工作坊#[br]持續交流最新科技
            a#read_more_elite_tech.opportunity__more(href="#" @click.prevent="setPopup({type: 'recruitment', position: 'tech'})") #[span Read More]
            ul.opportunity__buttons.buttons
              li
                a#btn_elite_tech.opportunity__button.button(:href="`https://hr.sinyi.com.tw/proptech/?sinFrom=202211_tvc_${targetString}`" target="_blank" @click="clickApply('tech')") #[span 我要應徵]
      .characters
        .character
        .character
      a.top(href="#" @click.prevent="goToTop") #[span TOP]
    .section__logo
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Recruitment',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['targetString', 'currentPage']),
  },
  methods: {
    ...mapMutations(['setPopup']),
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    clickApply(position) {
      this.$trackEvent('introduction_apply', 'click', `apply_${position}`);
    }
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/recruitment/';

#recruitment {

  $root: &;
  position: relative;

  @at-root .page-quiz #recruitment {

    // padding-top: vwXL(132);

    @include tablet {
      padding-top: vw(132);
    }

    .section__logo {

      display: block;
      content: '';
      position: absolute;
      top: vwXL(-101);
      left: vwXL(230);
      width: vwXL(185);
      height: vwXL(64);
      background-image: url('~@/assets/images/header/logo.png');
      background-position: 0 0;
      background-repeat: no-repeat;
      background-size: contain;
      opacity: 0;
      transition: opacity .5s ease;
      // margin: vwXL(31) 0 vwXL(31) vwXL(27);

      @include tablet {
        // display: block;
        top: vw(31);
        left: vw(27);
        width: vw(185);
        height: vw(64);
        opacity: 1;
        // margin: vw(31) 0 vw(31) vw(27);
      }

    }

  }

  @at-root .page-quiz.in #recruitment .section__logo {
    opacity: 1;
  }

  .section__content {
    position: relative;
    overflow: hidden;
  }

  // 標題
  .caption {

    position: relative;
    background-color: #07aa6d;
    background-position: 0 0;
    background-repeat: repeat;
    overflow: hidden;

    width: vwXL(1105);
    height: vwXL(689);
    // width: 660px;
    // height: 502px;
    margin-left: vwXL(230);
    border: #009944 vwXL(8) solid;
    background-image: url($assets + 'caption-background_desktop.png');
    // background-position: -3px 5px;
    background-size: vwXL(95) vwXL(87);
    animation: recruitmentCaptionBg 5s linear infinite forwards;

    --recruitmentCaptionX: #{vwXL(950)};
    --recruitmentCaptionY: #{vwXL(870)};

    @include tablet {

      width: vw(660);
      height: vw(502);
      margin-left: 0;
      border: #009944 vw(8) solid;
      border-left: 0;
      background-image: url($assets + 'caption-background.png');
      // background-position: vw(-3) vw(5);
      background-size: vw(69) vw(64);
      --recruitmentCaptionX: #{vw(690)};
      --recruitmentCaptionY: #{vw(640)};

    }

    @keyframes recruitmentCaptionBg {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: var(--recruitmentCaptionX) var(--recruitmentCaptionY);
      }
    }

    &__text {

      position: absolute;
      background-position: 0 0;
      background-repeat: no-repeat;

      top: vwXL(30);
      left: vwXL(40);
      width: vwXL(1056);
      height: vwXL(725);
      // top: 35px;
      // left: 36px;
      // width: 624px;
      // height: 459px;
      background-image: url($assets + 'caption_desktop.png');
      background-size: contain;
      animation: recruitmentCaptionText 2s ease-in-out infinite forwards;

      @include tablet {
        top: vw(35);
        left: vw(36);
        width: vw(624);
        height: vw(459);
        background-image: url($assets + 'caption.png');
        // background-size: contain;
        // animation: recruitmentCaptionText 2s ease-in-out infinite forwards;
      }

    }

    @keyframes recruitmentCaptionText {
      0% {
        transform: translate(0, -3%);
      }
      50% {
        transform: translate(2%, 0%);
      }
      100% {
        transform: translate(0, -3%);
      }
    }

  }

  // 工作機會群
  .opportunities {

    display: flex;
    flex-direction: column;

  }

  // 工作機會
  .opportunity {

    $opportunity: &;
    z-index: 1;

    &__title {
      position: relative;
      background: #07aa6d;
      z-index: 1;

      display: flex;
      align-items: center;
      justify-content: center;
      width: vwXL(704);
      height: vwXL(144);
      border: #c5f6e6 vwXL(15) solid;
      @include tablet {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        width: vw(506);
        height: vw(132);
        border: #c5f6e6 vw(15) solid;
      }
      p {
        color: #ffffff;
        font-size: vwXL(70);
        text-align: center;
        text-indent: vwXL(PsdLetterSpacing(160, 70));
        letter-spacing: vwXL(PsdLetterSpacing(160, 70));
        padding-bottom: vwXL(8);
        @include narrow-text;
        transform-origin: center top;
        @include tablet {
          font-size: vw(64);
          text-indent: vw(PsdLetterSpacing(160, 64));
          letter-spacing: vw(PsdLetterSpacing(160, 64));
          padding-bottom: vw(8);
        }
      }
    }

    &__content {
      position: relative;
      border: #c5f6e6 solid;
      border-width: vwXL(15);
      background: #07aa6d;
      z-index: 0;
      @include tablet {
        border-width: vw(15);
      }
    }

    &__desc {
      li {
        display: flex;
        &::before {
          content: '';
          width: vwXL(11);
          height: vwXL(11);
          margin-top: vwXL(20);
          margin-right: vwXL(19);
          @include tablet {
            width: vw(9);
            height: vw(9);
            margin-top: vw(16);
            margin-right: vw(17);
          }
        }
      }
      p {
        font-weight: 400;
        font-family: Arial, 'Noto Sans TC', 'sourcehansans-tc', 'Noto Sans S Chinese', 'PingFang TC', 'Microsoft JhengHei', Tahoma, Verdana, Helvetica, sans-serif;
        @include narrow-text;

        font-size: vwXL(45);
        line-height: lineHeight(45, 54);
        letter-spacing: vwXL(PsdLetterSpacing(45, 54));
        word-spacing: vwXL(-12);
        @include tablet {
          font-size: vw(32);
          line-height: lineHeight(32, 42);
          letter-spacing: vw(PsdLetterSpacing(35, 32));
          word-spacing: vw(-7);
        }
      }
    }

    &__more {
      position: relative;
      display: inline-block;
      color: #fff;
      font-size: vwXL(35);
      font-weight: normal;
      letter-spacing: vwXL(PsdLetterSpacing(60, 35));
      margin-top: vwXL(0);
      padding-bottom: vwXL(9);
      border-bottom: #fff vwXL(3) solid;
      @include tablet {
        font-size: vw(32);
        letter-spacing: vw(PsdLetterSpacing(60, 32));
        margin-top: vw(6);
        padding-bottom: vw(9);
        border-bottom: #fff vw(3) solid;
      }
      span {
        @include narrow-text;
      }
      &::after {
        content: '感應區加大';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 0;
        text-indent: -50000px;
        transform: scale(2, 2.6);
      }
    }

    &__buttons {
      position: absolute;
    }

    &__button {
      width: vwXL(414);
      height: vwXL(148);
      font-size: vwXL(58);
      text-indent: vwXL(PsdLetterSpacing(120, 58));
      letter-spacing: vwXL(PsdLetterSpacing(120, 58));
      background-size: vwXL(414) vwXL(300);
      @include blink-button(vwXL(-150), #134b2c);
      @include tablet {
        width: vw(276);
        height: vw(98);
        font-size: vw(40);
        text-indent: vw(PsdLetterSpacing(120, 40));
        letter-spacing: vw(PsdLetterSpacing(120, 40));
        // background-image: url($assets + 'button.png');
        background-size: vw(276) vw(200);
        @include blink-button(vw(-100), #134b2c);
      }
      span {
        @include wide-text;
        pointer-events: none;
      }
    }

  }

  // 業務人才
  .opportunity:nth-child(1) {
    
    align-self: flex-end;

    margin-bottom: vwXL(107); // (47 + 28) + px
    transform: translateY(vwXL(-134));

    @include tablet {
      margin-bottom: vw(47 + 28);
      transform: translateY(vw(-60));
    }

    .opportunity__title {
      transform: translateX(vwXL(257));
      @include tablet {
        transform: translateX(vw(-52));
      }
    }

    .opportunity__content {

      width: vwXL(1155);
      border-right: 0;
      margin-top: vwXL(-85);
      padding: vwXL(134) 0 vwXL(97) vwXL(82);

      background-image: url($assets + 'opportunity-background.png');
      background-position: right vwXL(16);
      background-repeat: repeat-y;
      background-size: vwXL(420) vwXL(87);

      @include tablet {
        width: vw(510);
        margin-top: vw(-47);
        padding: vw(53) 0 vw(74) vw(42);
        background-image: none;
      }

    }

    .opportunity__desc {

      li {
        margin-bottom: vwXL(17);
        @include tablet {
          margin-bottom: vw(16);
        }
        &::before {
          background: #fff;
        }
      }

      p {
        color: #fff;
      }

    }

    .opportunity__buttons {
      left: vwXL(77);
      bottom: vwXL(-88);
      @include tablet {
        left: vw(45);
        bottom: vw(-65);
      }
    }

    .opportunity__button {
      background-image: url($assets + 'button-1_desktop.png');
      @include tablet {
        background-image: url($assets + 'button-1.png');
      }
    }

  }

  // 數位人才
  .opportunity:nth-child(2) {

    margin-bottom: vwXL(227);
    margin-left: vwXL(398);

    @include tablet {
      margin-bottom: vw(49 + 25);
      margin-left: 0;
    }

    .opportunity__title {
      width: vwXL(706);
      padding-left: vwXL(4);
      background: #046b71;
      transform: translateX(vwXL(-244));
      @include tablet {
        width: vw(546);
        border-left: 0;
        padding-left: vw(4);
        transform: translateX(0);
        // background: #046b71;
      }
    }

    .opportunity__content {
      width: vwXL(934);
      margin-top: vwXL(-57);
      padding: vwXL(98) 0 vwXL(91) vwXL(114);
      // border-left: 0;
      background: #046b71;
      @include tablet {
        width: auto;
        margin-top: vw(-30);
        padding: vw(38) 0 vw(78) vw(65);
        border-left: 0;
        // background: #046b71;
      }
    }

    .opportunity__more {
      margin-top: 0;
      @include tablet {
        margin-top: vw(-4);
      }
    }

    .opportunity__desc {

      li {
        margin-bottom: vwXL(17);
        @include tablet {
          margin-bottom: vw(15);
        }
        &::before {
          background: #fff;
        }
      }

      p {
        color: #fff;
      }

    }

    .opportunity__buttons {
      left: vwXL(404);
      bottom: vwXL(-92);
      @include tablet {
        left: vw(230);
        bottom: vw(-66);
      }
    }

    .opportunity__button {
      background-image: url($assets + 'button-2_desktop.png');
      @include blink-button(vwXL(-150), #046b71);
      @include tablet {
        background-image: url($assets + 'button-2.png');
        @include blink-button(vw(-100), #046b71);
      }
    }

  }

  // TOP
  .top {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    color: #77b79e;
    text-align: center;
    z-index: 1;

    bottom: vwXL(36);
    left: vwXL(112);
    width: vwXL(120);
    height: vwXL(120);
    // background: #000;

    @include tablet {
      bottom: vw(16);
      left: vw(43);
      width: vw(88);
      height: vw(88);
    }

    &::before {
      content: '';
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;

      width: vwXL(98);
      height: vwXL(27);
      margin-top: vwXL(6);
      margin-bottom: vwXL(18);
      background-image: url($assets + 'top_desktop.png');

      @include tablet {
        width: vw(62);
        height: vw(18);
        margin-top: vw(2);
        margin-bottom: vw(10);
        background-image: url($assets + 'top.png');
      }
    }
    span {
      font-family: Arial, 'Noto Sans TC', 'sourcehansans-tc', 'Noto Sans S Chinese', 'PingFang TC', 'Microsoft JhengHei', Tahoma, Verdana, Helvetica, sans-serif;
      @include narrow-text;
      transform-origin: center top;

      font-size: vwXL(48);
      text-indent: vwXL(PsdLetterSpacing(120, 48));
      letter-spacing: vwXL(PsdLetterSpacing(120, 48));
      
      @include tablet {
        font-size: vw(30);
        text-indent: vw(PsdLetterSpacing(120, 30));
        letter-spacing: vw(PsdLetterSpacing(120, 30));
      }
    }
  }

  // 人物
  .character {
    position: absolute;
    background-position: 0 0;
    background-repeat: no-repeat;
    pointer-events: none;
  }

  // 柚子
  .character:nth-child(1) {
    top: vwXL(803);
    left: 50%;
    width: vwXL(699);
    height: vwXL(734);
    background-image: url($assets + 'character-1-body_desktop.png');
    background-size: vwXL(699) vwXL(734);
    z-index: 1;
    transform: translateX(vwXL(-780));
    @include tablet {
      top: vw(823);
      left: 0;
      width: vw(313);
      height: vw(462);
      background-image: url($assets + 'character-1-body.png');
      background-size: vw(313) vw(345);
      transform: none;
      // z-index: 1;
    }
  }

  .character:nth-child(2) {
    bottom: 0;
    left: 50%;
    width: vwXL(703);
    height: vwXL(1550);
    background-image: url($assets + 'character-2-body_desktop.png');
    background-size: vwXL(703) vwXL(1550);
    z-index: 1;
    transform: translateX(vwXL(257));
    @include tablet {
      right: 0;
      bottom: vw(0);
      left: auto;
      width: vw(275);
      height: vw(709);
      background-image: url($assets + 'character-2-body.png');
      background-size: vw(275) vw(709);
      transform: none;
      // z-index: 1;
    }
  }

  // 額外物件
  .section__content::before {
    content: '';
    position: absolute;
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;

    top: vwXL(558);
    left: vwXL(189);
    width: vwXL(1063);
    height: vwXL(741);
    background-image: url($assets + 'extra-1_desktop.png');
    z-index: 1;

    @include tablet {
      top: vw(552);
      left: vw(52);
      width: vw(369);
      height: vw(361);
      background-image: url($assets + 'extra-1.png');
      z-index: -1;
    }
  }

  .section__content::after {
    content: '';
    position: absolute;
    background-position: 0 0;
    background-repeat: no-repeat;
    z-index: -1;

    top: vwXL(16);
    left: 0;
    width: 100%;
    height: vwXL(2040);
    background-image: url($assets + 'extra-2_desktop.png');
    background-position: center top;
    background-size: vwXL(1920) vwXL(2040);

    @include tablet {
      top: vw(814);
      left: vw(-35);
      width: vw(471);
      height: vw(410);
      background-image: url($assets + 'extra-2.png');
      background-size: contain;
    }
  }

}

</style>
